import { useHistory } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { LeftOutlined } from "@ant-design/icons";

export const BackBtn = ({ wIcon, iconOnly, ...others }) => {
    const history = useHistory();

    return (
        <Tooltip title="Navigate to previous page">
            <Button icon={wIcon || iconOnly ? <LeftOutlined /> : null} onClick={() => history.goBack()} {...others}>
                {!iconOnly && "Go back"}
            </Button>
        </Tooltip>
    );
};
